module.exports = __webpack_public_path__ + "media/images/placeholders/worker-placeholder-6c3996c0f553b7e75bdd6a11c708fe80.jpg";